import { useEffect, useState } from 'react';
import { useMap } from 'react-leaflet';

import { getSelectedSection } from '../Helpers/getSelectedSection';

const useMyLocation = (getLatLng?: (val: { lat: number; lng: number }) => void, getSection?: (val: string | null) => void) => {
    const [position, setPosition] = useState(null);
    const map = useMap();

    useEffect(() => {
        const handleMyLocationClick = (e: any) => {
            // Redirect to my location and trigger callback functions to get latitude, longitude and section
            if (e.target.id) {
                map.locate().on('locationfound', (e: any) => {
                    setPosition(e.latlng);
                    getLatLng && getLatLng(e.latlng);
                    getSection && getSection(getSelectedSection([e.latlng.lat, e.latlng.lng]));
                    map.flyTo(e.latlng, map.getZoom());
                });
            }
        };

        window.addEventListener('click', handleMyLocationClick);
        window.addEventListener('touchstart', handleMyLocationClick);
        return () => {
            window.removeEventListener('click', handleMyLocationClick);
            window.removeEventListener('touchstart', handleMyLocationClick);
        };
    }, [getLatLng, getSection, map]);


    return position as { lat: number; lng: number } | null;
};

export default useMyLocation;
